module.exports = __webpack_public_path__ + "img/sc_4.56eff632.jpg";